import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import config from '../../../config/config'
import CurrencyFormat from 'react-currency-format';

class PaymentConfirmation extends Component {
  render() {
    if (this.props.currentStep !== 2) {
      return null
    }
    return (
      <form onSubmit={this.props.handleConfirmSubmit} className="confirmForm">
        <h2 className="text-center"><FormattedMessage id="CreateDomainLabel.inputConfirmation"/></h2>
        <p className="text-center"><FormattedMessage id="CreateDomainLabel.checkInformation"/></p>
        <div className="box-shadow form-box">
          <div className="box-header">
            <FormattedMessage id="plan.plan"/>
          </div>
          <div className="box-body">
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.idNumbers"/>
                </label>
              </div>
              <div className="space-right">
                <div className="width120">
                  {this.props.accounts_allowed} ID
                </div>
              </div>
            </div>
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.roomNumbers"/>
                </label>
              </div>
              <div className="space-right">
                <div className="width120">
                  {this.props.rooms_allowed} <FormattedMessage id="CreateDomainLabel.room"/>
                </div>
              </div>
            </div>
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.domainCompany"/>
                </label>
              </div>
              <div className="space-right">
                <div className="width170">
                  {this.props.domain_name}
                </div>
              </div>
            </div>
            <div className="input-row confirmPrice">
              <div>
                <label>
                <FormattedMessage id="CreateDomainLabel.price"/>
                </label>
              </div>
              <div className="space-right">
                <div className="">
                  <p><FormattedMessage id="CreateDomainLabel.initialPrice"/>:
                  { this.props.campaign ?
                    <span className="price-value">￥0</span>
                  :
                    <span className="price-value"> <CurrencyFormat value={this.props.initial_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded"/></span>
                  }
                  </p>
                  <p><FormattedMessage id="CreateDomainLabel.monthlyCost"/>: <span className="price-value"> <CurrencyFormat value={this.props.total_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded"/></span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="back-btn confirm-btns" onClick={this.props._prev}> <FormattedMessage id="CreateDomainLabel.back"/> </button>
        <button type="submit" className="btn confirm-btns"><FormattedMessage id="CreateDomainLabel.confirm"/></button>
      </form>
    );
  }
}

export default PaymentConfirmation



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/PaymentConfirmation.js